import { Box, Button, TextField } from '@mui/material';
import { useState } from 'react';
import KitModal from '../UI/KitModal';

interface VersionNameModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (versionName: string) => void;
  title: string;
  label?: string;
  placeholder?: string;
  submitButtonText?: string;
}

const VersionNameModal = ({
  show,
  onHide,
  onSubmit,
  title,
  label = 'Enter version name',
  placeholder = 'V 2.0',
  submitButtonText = 'Create',
}: VersionNameModalProps) => {
  const [versionName, setVersionName] = useState('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (versionName.trim()) {
      onSubmit(versionName.trim());
      setVersionName('');
    }
  };

  const handleClose = () => {
    setVersionName('');
    onHide();
  };

  return (
    <KitModal
      onHide={handleClose}
      show={show}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '500px',
          width: '100%',
        },
      }}
      title={title}
    >
      <form onSubmit={handleSubmit}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          gap="1rem"
        >
          <TextField
            id="version-name-input"
            label={label}
            variant="outlined"
            type="text"
            name="versionName"
            value={versionName}
            onChange={(e) => setVersionName(e.target.value)}
            placeholder={placeholder}
            fullWidth
            autoFocus
          />

          <Box alignSelf="flex-end" display="flex" gap="0.5rem">
            <Button
              onClick={handleClose}
              variant="outlined"
              size="small"
            >
              Cancel
            </Button>
            <Button
              disabled={!versionName.trim()}
              type="submit"
              variant="contained"
              size="small"
            >
              {submitButtonText}
            </Button>
          </Box>
        </Box>
      </form>
    </KitModal>
  );
};

export default VersionNameModal;
